module.exports = __webpack_public_path__ + "static/media/underpaid.32fa2487.png";